export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14248.66d3d890.jpg";